import React from "react";
import AuditSecurityComponent from "../../../containers/administration/auditSecurity/auditSecurityComponent";

import styles from "./auditSecurity.module.css";

const AuditSecurity = () => {
  return (
    <div className={styles["component-container"]}>
      <h2 className={styles["component-caption"]}>Аудит безопасности</h2>
      <AuditSecurityComponent />
    </div>
  );
};

export default AuditSecurity;
